import state from './camera.state'
import mutations from './camera.mutations'
import actions from './camera.actions'

export default {
  state,
  mutations,
  actions
}
